import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import ContactFormModal from "./overlays/ContactFormModal";

function NavBar() {

    var translationHook = useTranslation();
    var i18n = translationHook.i18n;
    var t = translationHook.t;

    var [isModalOpen, setIsModalOpen] = React.useState(false);

    var location = useLocation();
    var [customClass, setCustomClass] = useState("custom-navbar-landing"); // default landing page

    useEffect(() => {
        if (location.pathname === "/") {
            setCustomClass("custom-navbar-landing");
        } else {
            setCustomClass("custom-navbar-subpage");
        }
    }, [location.pathname]);

    function changeLanguageToEnglish() {
        window.localStorage.setItem("i18nextLng", "en");
        i18n.changeLanguage("en");
    }

    function changeLanguageToRussian() {
        window.localStorage.setItem("i18nextLng", "ru");
        i18n.changeLanguage("ru");
    }

    /* function changeLanguageToFrench() {
        window.localStorage.setItem("i18nextLng", "fr");
        i18n.changeLanguage("fr");
    } */

    function changeLanguageToQazaq() {
        window.localStorage.setItem("i18nextLng", "kk");
        i18n.changeLanguage("kk");
    }

    React.useEffect(() => {
        if (window.UIkit) {
            window.UIkit.update();
        }
    }, []);

    return (
        <nav className={`uk-navbar-container uk-background-primary uk-light ${customClass}`}
            uk-sticky="top:0; animation:uk-animation-slide-top"
            style={{ zIndex: 1000 }}
        >

            <ContactFormModal
                isOpen={isModalOpen}
                onClose={function () { setIsModalOpen(false); }}
            />

            <div className="container">
                {/* UIKit navbar wrapper */}
                <div uk-navbar="true">

                    {/* Left: Logo */}
                    <div className="uk-navbar-left uk-margin-left">
                        <a className="uk-navbar-item uk-logo" href="/" aria-label="Back to Home">
                            <img
                                src="/logoWhite.png"
                                alt="Jai Logo"
                                style={{ height: "32px", width: "auto" }}
                            />
                        </a>
                    </div>

                    {/* Mobile menu toggle */}
                    <div className="uk-navbar-right uk-hidden@m uk-margin-right">
                        <a
                            className="uk-navbar-toggle white-icon"
                            onClick={() => window.UIkit.offcanvas("#burgermenu").show()}
                            aria-label="Menu"
                        >
                            <span uk-icon="menu"></span>
                        </a>
                    </div>

                    {/* Right: Desktop Menu */}
                    <div className="uk-navbar-right uk-visible@m uk-margin-right">
                        <ul className="uk-navbar-nav">
                            <li><a href="/">{t("ui.pages.home")}</a></li>
                            <li className="uk-inline">
                                <a href="/why-jai">{t("ui.pages.why_jai")}</a>
                                <div uk-dropdown="mode: hover">See how we can help you achieve your professional and educational goals.</div>
                            </li>
                            <li className="uk-inline">
                                <a href="/about">{t("ui.pages.about")}</a>
                                <div uk-dropdown="mode: hover">Learn more about the founder and his journed from UK to Kazakhstan that led to Jai International.</div>
                            </li>
                            <li className="uk-inline">
                                <a href="/team">{t("ui.pages.contacts")}</a>
                                <div uk-dropdown="mode: hover">Team members and their contacts.</div>
                            </li>

                            <li><a href="#">{t("ui.pages.services_dropd")}</a>
                                <div className="uk-navbar-dropdown">
                                    <ul className="uk-nav uk-navbar-dropdown-nav">
                                        <li><a className="jai-link" href="/travel-overview">{t("ui.pages.dropd_travel_kz")}</a></li>
                                        <li><a className="jai-link" href="/work-overview">{t("ui.pages.dropd_work_kz")}</a></li>
                                        <li><a className="jai-link" href="/study-overview">{t("ui.pages.dropd_study_kz")}</a></li>
                                        <li><a className="jai-link" href="/investment/open-company">{t("ui.pages.dropd_investment")}</a></li>
                                    </ul>
                                </div>
                            </li>

                            <li><a href="#">{t("ui.nav.account")}</a>
                                <div className="uk-navbar-dropdown">
                                    <ul className="uk-nav uk-navbar-dropdown-nav">
                                        <li><a className="jai-link" href="/sign-in">{t("ui.account.login")}</a></li>
                                        {/*<li><a className="jai-link" href="/sign-up">{t("ui.pages.account_create")}</a></li>*/}
                                    </ul>
                                </div>
                            </li>

                            <li><a href="#"><span uk-icon="icon: world"></span></a>
                                <div className="uk-navbar-dropdown">
                                    <ul className="uk-nav uk-navbar-dropdown-nav">
                                        <li>
                                            <a className="jai-link" href="#" onClick={changeLanguageToEnglish}>
                                                <picture>
                                                    <source
                                                        type="image/webp"
                                                        srcset="https://flagcdn.com/40x30/gb.webp,
                                                        https://flagcdn.com/80x60/gb.webp 2x,
                                                        https://flagcdn.com/120x90/gb.webp 3x"/>
                                                    <source
                                                        type="image/png"
                                                        srcset="https://flagcdn.com/40x30/gb.png,
                                                        https://flagcdn.com/80x60/gb.png 2x,
                                                        https://flagcdn.com/120x90/gb.png 3x"/>
                                                    <img
                                                        src="https://flagcdn.com/40x30/gb.png"
                                                        width="40"
                                                        height="30"
                                                        alt="English"/>
                                                </picture>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="jai-link" href="#" onClick={changeLanguageToQazaq}>
                                                <picture>
                                                    <source
                                                        type="image/webp"
                                                        srcset="https://flagcdn.com/40x30/kz.webp,
                                                        https://flagcdn.com/80x60/kz.webp 2x,
                                                        https://flagcdn.com/120x90/kz.webp 3x"/>
                                                    <source
                                                        type="image/png"
                                                        srcset="https://flagcdn.com/40x30/kz.png,
                                                        https://flagcdn.com/80x60/kz.png 2x,
                                                        https://flagcdn.com/120x90/kz.png 3x"/>
                                                    <img
                                                        src="https://flagcdn.com/40x30/kz.png"
                                                        width="40"
                                                        height="30"
                                                        alt="Qazaq"/>
                                                </picture>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="jai-link" href="#" onClick={changeLanguageToRussian}>
                                                <picture>
                                                    <source
                                                        type="image/webp"
                                                        srcset="https://flagcdn.com/40x30/ru.webp,
                                                        https://flagcdn.com/80x60/ru.webp 2x,
                                                        https://flagcdn.com/120x90/ru.webp 3x"/>
                                                    <source
                                                        type="image/png"
                                                        srcset="https://flagcdn.com/40x30/ru.png,
                                                        https://flagcdn.com/80x60/ru.png 2x,
                                                        https://flagcdn.com/120x90/ru.png 3x"/>
                                                    <img
                                                        src="https://flagcdn.com/40x30/ru.png"
                                                        width="40"
                                                        height="30"
                                                        alt="Russki"/>
                                                </picture>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>


                        </ul>

                        <div className="uk-navbar-item uk-flex-between">

                            {/* Social icons */}
                            <a href="https://wa.me/77750912804" target="_blank" rel="noopener noreferrer" uk-icon="whatsapp"></a>
                            <a href="https://www.instagram.com/jai_agency.travels?igsh=MXZ1cmczNHlwZ3U3cg==&utm_source=ig_contact_invite" target="_blank" rel="noopener noreferrer" uk-icon="instagram"></a>
                            <a href="https://www.facebook.com/share/16G4ta5r73/" target="_blank" rel="noopener noreferrer" uk-icon="facebook"></a>
                            <a href="https://www.tiktok.com/@jai.international?_t=ZM-8zm6w4LRtmI&_r=1" target="_blank" rel="noopener noreferrer" uk-icon="tiktok"></a>

                            {/* Вот здесь висит правильная кнопка которая должна вызывать modal */}
                            <button className="uk-button uk-button-primary uk-margin-left" onClick={function () { setIsModalOpen(true); }}>
                                {t("ui.button.business_action.msg")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>

    );


}

export default NavBar;
